import { sendWebsocketMessage } from '../../../../../../App';

export function closePctPosition(
  tradePlanId,
  pct,
  symbol,
  limitPrice,
  cancelOpenOrders
) {
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'userPctClose',
    value: {
      pct,
      symbol,
      limitPrice,
      cancelOpenOrders,
    },
  };
  sendWebsocketMessage(msg);
}
